export default __webpack_public_path__ + "static/media/south_ossetia.3ca5096b.svg";